import { Locale } from './locales';

export interface MultilingualText extends Partial<Record<Locale, string>> {
  [Locale.de]: string;
}

export enum WorkCategory {
  GOBELIN = 'gobelin',
  MOSAIC = 'mosaic',
  RELIEF = 'relief',
  PAINTING = 'painting',
  GLASS_PAINTING = 'glassPainting',
  SCULPTURE = 'sculpture',
  MURAL_AND_WALL_PAINTING = 'muralAndWallPainting'
}

export type WorkId = string;

export type Tag = string;
export type MultiLingualTags = Array<MultilingualText>;
export type TagsList = Array<Tag>;

export interface Work {
  id: WorkId;
  artist: string;
  title: string;
  year: string;
  street?: string;
  postalCode?: string;
  city: string;
  latitude: number;
  longitude: number;
  sponsor: MultilingualText;
  photos: Array<{ name: string; url: string }>;
  photoCredits: MultilingualText;
  description: MultilingualText;
  category: WorkCategory;
  tags: MultilingualText;
  registrationNumber: string;
  published: boolean;
  userConsent: boolean;
  userEmail?: string;
  userName?: string;
  citizenScience?: boolean;
}

export type WorksList = Array<Omit<Work, 'photos'>>;

export type DatabaseWork = Omit<Work, 'id' | 'photos'>;

export interface WorkFormData
  extends Omit<
    Work,
    | 'id'
    | 'sponsor'
    | 'photoCredits'
    | 'description'
    | 'category'
    | 'photos'
    | 'published'
    | 'userConsent'
  > {
  'sponsor.de': string;
  'sponsor.en': string;
  'photoCredits.de': string;
  'photoCredits.en': string;
  'description.de': string;
  'description.en': string;
  category: string;
  'tags.de': Tag;
  'tags.en': Tag;
  photosToDelete: Array<string> | '';
  published?: 'true';
  userConsent?: 'true';
  userName?: string;
  userEmail?: string;
}
